import { Box } from '@mui/material';
import { EnabledDocuments } from '../../../utils/headers';
import { useGetEnabledDocsQuery } from '../../../services/documentsApi';
import DataTable from '../../Table/DataTable';
import DialogComponent from '../../Dialog/DialogComponent';
import Loading from '../../Loading';

function DocumentosHabilitados({ openEnableDocsModal, setOpenEnableDocsModal }: any) {
    const {
        data: enabledDocs,
        isLoading: loadingEnabledDocs,
        isFetching: fetchingEnabledDocs
    } = useGetEnabledDocsQuery(undefined, {
        skip: !openEnableDocsModal,
        refetchOnMountOrArgChange: true
    });

    return (
        <DialogComponent
            title="Documentos habilitados"
            handleSubmit={() => setOpenEnableDocsModal(false)}
            loading={false}
            handleCloseDialog={() => setOpenEnableDocsModal(false)}
            openDialog={openEnableDocsModal}
            confirmBtnText="Volver"
        >
            <Box sx={{ height: 'auto', maxHeight: '400px' }}>
                {loadingEnabledDocs || fetchingEnabledDocs ? (
                    <Loading />
                ) : (
                    <DataTable
                        headers={EnabledDocuments}
                        loading={loadingEnabledDocs || fetchingEnabledDocs}
                        hideFooterPagination
                        options={enabledDocs}
                    />
                )}
            </Box>
        </DialogComponent>
    );
}

export default DocumentosHabilitados;
